module.exports = __webpack_public_path__ + "img/klientix.png";